import {datadogRum} from '@datadog/browser-rum';

export default (event, options) => {
    if (typeof window === 'undefined') {
        return;
    }
    if (event === 'track') {
        datadogRum.addAction(options.name, options.data);
    }
}